import {createAction, props} from '@ngrx/store';
import {Order} from './orders.reducer';

export const loadOrderss = createAction(
  '[Orders] Load Orderss'
);
export const createNewOrder = createAction(
  '[Orders] Create New Orders',
  props<{ order: any }>()
);
export const updateOrder = createAction(
  '[Orders] Update Order',
  props<{ order: any }>()
);
export const updateOrderSuccess = createAction(
  '[Orders] Update Order Success',
  props<{ order: any }>()
);
export const updateOrderFailed = createAction(
  '[Orders] Update Order Failed',
  props<{ error: string }>()
);
export const createNewOrderSuccess = createAction(
  '[Orders] Create New Orders Success',
  props<{ order: Order }>()
);

export const createNewOrderFailed = createAction(
  '[Orders] Create New Orders Failed',
  props<{ errors: any[] }>()
);

export const InitNewOrder = createAction(
  '[Orders] Init New Order',
);

export const GetPreviousOrders = createAction(
  '[Orders] Get Previous Orders',
);

export const GetPreviousOrdersSuccess = createAction(
  '[Orders] Get Previous Orders Success',
  props<{ orders: Order[] }>()
);
export const GetPreviousOrdersFailed = createAction(
  '[Orders] Get Previous Orders Failed',
  props<{ error: any }>()
);


export const GetSingleOrder = createAction(
  '[Orders] Get Single Order',
  props<{ id: number }>()
);
export const GetSingleOrderSuccess = createAction(
  '[Orders] Get Single Order Success',
  props<{ order: Order }>()
);
export const GetSingleOrderFailed = createAction(
  '[Orders] Get Single Order Failed',
  props<{ error: string }>()
);
